import { ValueState } from '@ui5/webcomponents-react';
import { BaseQueryDetailsFragment, Status } from 'generated/graphql';
import { IssueTypeOptions } from 'stores/interfaces/CommonQueryState';
import { UpdateBaseQueryState } from 'stores/interfaces/UpdateQueryState';
import { SetState } from 'zustand';

export const detailsQueryInitialState = {
  assignee: '',
  assigneeValueState: ValueState.None,
  selectedStatus: Status.NEW,
  statusValueState: ValueState.None,
  deadline: '',
  deadlineValueState: ValueState.None,
  distributions: [] as string[],
  resetedDistributions: [] as string[],
  qeReview: true
};

export const createUpdateBaseQuerySlice = (set: SetState<UpdateBaseQueryState>) => ({
  ...detailsQueryInitialState,
  setAssignee: (value: string) => set(() => ({ assignee: value })),
  setAssigneeValueState: (value: ValueState) => set(() => ({ assigneeValueState: value })),
  setSelectedStatus: (value: Status) => set(() => ({ selectedStatus: value })),
  setStatusValueState: (value: ValueState) => set(() => ({ statusValueState: value })),
  setDeadline: (value: string) => set(() => ({ deadline: value })),
  setDeadlineValueState: (value: ValueState) => set(() => ({ deadlineValueState: value })),
  setDistributions: (value: string[]) => set(() => ({ distributions: value })),
  setResetedDistributions: (value: string[]) => set(() => ({ resetedDistributions: value })),
  setQEReview: (value: boolean) => set(() => ({ qeReview: value })),
  resetAllData: () =>
    set({
      targetLanguage: '',
      targetLanguageValueState: ValueState.None,
      sourceText: '',
      sourceTextValueState: ValueState.None,
      targetText: '',
      details: '',
      selectedIssueType: IssueTypeOptions.NOT_SELECTED_ISSUE_TYPE,
      issueTypeValueState: ValueState.None,
      assigneeValueState: ValueState.None,
      deadline: '',
      deadlineValueState: ValueState.None,
      distributions: [],
      resetedDistributions: []
    }),
  setInitialStateWithProps: (queryDetails: BaseQueryDetailsFragment) =>
    set({
      deadline: queryDetails.deadline,
      sourceText: queryDetails.sourceText || '',
      targetText: queryDetails.targetText || '',
      targetLanguage: queryDetails.targetLanguage,
      selectedIssueType: queryDetails.issueType,
      selectedStatus: queryDetails.status,
      details: queryDetails.details || '',
      assignee: queryDetails.assignee || '',
      assigneeValueState: ValueState.None,
      statusValueState: ValueState.None,
      deadlineValueState: ValueState.None,
      targetLanguageValueState: ValueState.None,
      issueTypeValueState: ValueState.None,
      sourceTextValueState: ValueState.None,
      languages: queryDetails.project.languages.map((projectLanguage) => projectLanguage?.language),
      resetedDistributions: [],
      distributions: queryDetails.distributions.reduce((acc: string[], distribution) => {
        if (distribution.distribute === true) {
          acc.push(distribution.language.id);
        }
        return acc;
      }, []),
      qeReview: queryDetails.qeReview
    })
});
